import ArrowIcon from '@/shared/ui/svgs/ArrowIcon';

import AsteriskLight from './asterisk-light.svg';
import Asterisk from './asterisk.svg';
import ClockIcon from './ClockIcon.svg';
import Filter from './Filter.svg';
import IndicatorWhite from './Indicator-white.svg';
import LocationCircleLight from './location-circle-light.svg';
import LocationCircle from './location-circle.svg';
import MoAsterisk from './mo-asterisk.svg';
import MoCustomerCenter from './mo-customerCenter.svg';
import MoGrayPlusIcon from './mo-grayPlusIcon.svg';
import MoLocationCircle from './mo-location-circle.svg';
import MoPaperPlane from './mo-paper-plane.svg';
import MoWhitePlusIcon from './mo-whitePlusIcon.svg';
import PaperPlaneLight from './paper-plane-light.svg';
import PaperPlane from './paper-plane.svg';
import PlusIcon from './PlusIcon';
import MoXIcon from './xIcon.svg';

export {
  MoAsterisk,
  MoLocationCircle,
  MoPaperPlane,
  MoCustomerCenter,
  ArrowIcon,
  PaperPlane,
  PaperPlaneLight,
  LocationCircle,
  LocationCircleLight,
  Asterisk,
  AsteriskLight,
  PlusIcon,
  IndicatorWhite,
  ClockIcon,
  Filter,
  MoWhitePlusIcon,
  MoGrayPlusIcon,
  MoXIcon,
};
